// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"535":"fce15c24","900":"8a0ad4ec"}[chunkId] + ".chunk.js";
};